export default __webpack_public_path__ + "static/media/TF_portfolio_color.15e5548e.png";